import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { UserLineup } from '../../../interfaces/settings';
import BroadcastBlue from '../../../img/Icons/Blue Icons/TitanTV Icon_Broadcast_Blue.png';
import CableBlue from '../../../img/Icons/Blue Icons/TitanTV Icon_Cable_Blue.png';
import DigitalBlue from '../../../img/Icons/Blue Icons/TitanTV Icon_Digital_Blue.png';
import SatelliteBlue from '../../../img/Icons/Blue Icons/TitanTV Icon_Satellite_Blue.png';
import StreamingBlue from '../../../img/Icons/Blue Icons/TitanTV Icon_Streaming_Blue.png';
import CustomBlue from '../../../img/Icons/Blue Icons/TitanTV Icon_Custom_Lineup_Blue.png';
import {
	LineupContainter, LineupTextContent, LineupIcon, LineupName, LineupLocation, LineupTimeZone, LineupSelectionContent
} from '../components/SettingsStyles'
import { CheckBox } from '../../Global/GobalStyledComponents';
import { selectLineupTransferList, setAddLineupTransferList, setRemoveLineupTransferList } from '../SettingsState/userSlice';
import { useEffect } from 'react';
import { selectLineups } from '../SettingsState/lineupsSlice';


// needs a UserLineup and isDefault passed as props
export const LineupSelectionBox = (props: any) => {
	const lineup: UserLineup = props.lineup;
	const index: number = props.indxe;
	let icon = '';
	const dispatch = useAppDispatch();
	const lineupSelection = useAppSelector(selectLineupTransferList);
	const userLineups = useAppSelector(selectLineups);

	const isChecked = (lineup: UserLineup): boolean => {
		for (let i = 0; i < lineupSelection.length; i++) {
			if (lineupSelection[i] === lineup.lineupId) {
				return true;
			}
		}
		return false;
	}

	if (userLineups.lineups.length + index + 1 < 9) {
		dispatch(setAddLineupTransferList(lineup.lineupId));
	}

	useEffect(() => {


	}, [])

	/*
		B - broadcast
			Digital Cable
		[C - cable ready TV
		D - digital cable]

		O - live streaming
			Analog Cable
		[A - analog cable
		R - cable rebuild lineup]

		S - satellite
	*/

	switch (lineup.deviceType) {
		case 'B':
			icon = BroadcastBlue
			break;
		case 'C':
		case 'D':
			icon = DigitalBlue
			break;
		case 'O':
			icon = StreamingBlue
			break;
		case 'S':
			icon = SatelliteBlue
			break;
		case 'R':
		case 'A':
			icon = CableBlue
			break;
		default:
			icon = CustomBlue
			break;
	}

	const handleCheck = (e: React.ChangeEvent<HTMLInputElement>, lineup: UserLineup) => {
		if (e.target.checked) {
			dispatch(setAddLineupTransferList(lineup.lineupId));
		} else {
			dispatch(setRemoveLineupTransferList(lineup.lineupId));
		}
	}

	return (
		<LineupContainter isDefault={false}>
			<LineupSelectionContent>
				<CheckBox id={`ChcekBox${lineup.lineupId}`} checked={isChecked(lineup)} onChange={(e) => handleCheck(e, lineup)} />
				<LineupIcon isDefault={false} src={icon} />
				<LineupTextContent isDefault={false}>
					<LineupName>{lineup.lineupName}</LineupName>
					<LineupLocation>
						{lineup.providerName}
					</LineupLocation>
					<br />
					<LineupTimeZone>
						Time Zone: {lineup.timeZone} ({(lineup.utcOffset / 60)} GMT)
					</LineupTimeZone>
					<div>
						Observe Daylight Savings: {lineup.observesDst ? 'Yes' : 'No'}
					</div>
					<br />
				</LineupTextContent>
			</LineupSelectionContent>
		</LineupContainter>
	)
}

export default LineupSelectionBox